import React from "react";
import { Link } from "react-router-dom";

class ProductReview extends React.Component {
  render() {
    return (
      <div className="card bordered-card is-shadowless animated fadeIn">
        <div className="card-header d-flex justify-content-between">
          <div className="card-header-title">Sample Review</div>
          <div className="m-2">
            <Link to="/myshop/home/?edit=true">
              <button className="button is-flat is-primary">
                <span className="zmdi zmdi-plus mr-1"></span>
                Create
              </button>
            </Link>
          </div>
        </div>
        <div className="card-content">
          <table className="table is-hoverable is-fullwidth ">
            <tbody>
              <tr>
                <td>
                  <strong>Product</strong>
                </td>
                <td>Flat Screen T.V</td>
              </tr>
              <tr>
                <td>
                  <strong>Unit Price</strong>
                </td>
                <td>XAF 100,000</td>
              </tr>
              <tr>
                <td>
                  <strong>Cost Price</strong>
                </td>
                <td>XAF 75,000</td>
              </tr>
              <tr>
                <td>
                  <strong>Current Stock</strong>
                </td>
                <td>8 units</td>
              </tr>
              <tr>
                <td>
                  <strong>Date Range</strong>
                </td>
                <td>Today, 2019-12-21</td>
              </tr>
              <tr>
                <td>
                  <strong>Qty Sold</strong>
                </td>
                <td>4 units</td>
              </tr>

              <tr>
                <td>
                  <strong>Expected Revenue</strong>
                </td>
                <td>XAF 400,000</td>
              </tr>

              <tr>
                <td>
                  <strong>Actual Revenue</strong>
                </td>
                <td>XAF 380,000</td>
              </tr>

              <tr>
                <td>
                  <strong>Profit</strong>
                </td>
                <td>XAF 80,000</td>
              </tr>

              <tr>
                <td>
                  <strong>Min Stock</strong>
                </td>
                <td>6 units</td>
              </tr>
              <tr>
                <td>
                  <strong>Max Stock</strong>
                </td>
                <td>26 units</td>
              </tr>

              <tr>
                <td>
                  <strong>Order</strong>
                </td>
                <td>16 units</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default ProductReview;
